import { Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function Hero() {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-blue-50 to-white py-20 sm:py-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          {/* SafeIdea Logo */}
          <div className="mb-8">
            <img
              src="/logo.svg"
              alt="SafeIdea.ai"
              className="mx-auto h-32 w-32 sm:h-40 sm:w-40 lg:h-48 lg:w-48"
            />
          </div>

          {/* SafeIdea Brand Name */}
          <div className="mb-6">
            <h1 className="text-5xl font-bold tracking-tight text-gray-900 sm:text-6xl lg:text-7xl">
              SafeIdea<sup className="text-sm">™</sup>
            </h1>
            <p className="mt-2 text-2xl text-blue-600 font-medium sm:text-3xl">
              AI for Legal Professionals
            </p>
          </div>

          {/* Beta Badge */}
          <div className="mb-8 inline-flex items-center gap-2 rounded-full bg-blue-100 px-5 py-3 text-base font-medium text-blue-700">
            <Sparkles className="h-4 w-4" />
            Early Beta - Limited Access Available
          </div>

          {/* Headline */}
          <h2 className="mb-6 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl lg:text-6xl">
            Capable. Secure. Affordable.
          </h2>

          {/* Subheadline */}
          <p className="mb-8 text-2xl text-gray-600 sm:text-3xl max-w-2xl mx-auto">
            The only AI platform that gives legal professionals all three—without compromise.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Button size="lg" className="w-full sm:w-auto" asChild>
              <a href="#beta-signup">Apply for Beta Access</a>
            </Button>
            <Button size="lg" variant="outline" className="w-full sm:w-auto" asChild>
              <a href="#the-problem">Learn More</a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
